<script lang="ts">
  import { navigating } from '$app/state';
  import { requestProgress } from '$lib/state/request-progress.svelte';

  // Combine SvelteKit page-load progress with our API in-flight counter.
  let busy = $derived(navigating.to !== null || requestProgress.count > 0);
</script>

{#if busy}
  <div
    class="fixed top-0 left-0 right-0 h-1 z-[60] overflow-hidden pointer-events-none bg-blue-100/60"
    role="progressbar"
    aria-label="Loading"
  >
    <div
      class="h-full w-1/3 bg-blue-500 animate-progress shadow-[0_0_8px_rgba(59,130,246,0.6)]"
    ></div>
  </div>
{/if}

<style>
  @keyframes progress {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(400%);
    }
  }
  .animate-progress {
    animation: progress 1s ease-in-out infinite;
  }
</style>
